import React from 'react';

class RoundDisplay extends React.Component {
  constructor(props) {
    super(props);
    this.handleMouseOver = this.handleMouseOver.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  handleMouseOver() {
    this.props.showSnags();
  }

  handleMouseLeave() {
    this.props.hideSnags();
  }

  render() {
    return (
      <div>
        {this.props.mode === "Responding" || this.props.mode === "Game Over" ? <h1 className="roundResponding" onMouseOver={this.handleMouseOver} onMouseLeave={this.handleMouseLeave} >Round {this.props.round} Score<br/> {this.props.snagBonus > 1 ? this.props.roundScore.toLocaleString('en')+" x"+this.props.snagBonus : this.props.roundScore+""}</h1> : <h1 className="leftTitleText">Round {this.props.round}</h1>}
      </div>
    )
  }
}

export default RoundDisplay;



// WEBPACK FOOTER //
// ./src/Components/RoundDisplay/RoundDisplay.js